// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_EVENTS = 'event/fetchEvents';
export const {
  pending: FETCH_EVENTS_PENDING,
  fulfilled: FETCH_EVENTS_FULFILLED,
  rejected: FETCH_EVENTS_REJECTED,
} = createAsyncActionTypes(FETCH_EVENTS);

export const FETCH_CORRESPONDENCE = 'event/fetchCorrespondence';
export const {
  pending: FETCH_CORRESPONDENCE_PENDING,
  fulfilled: FETCH_CORRESPONDENCE_FULFILLED,
  rejected: FETCH_CORRESPONDENCE_REJECTED,
} = createAsyncActionTypes(FETCH_CORRESPONDENCE);

export const FETCH_EMAILS = 'event/fetchEmails';
export const {
  pending: FETCH_EMAILS_PENDING,
  fulfilled: FETCH_EMAILS_FULFILLED,
  rejected: FETCH_EMAILS_REJECTED,
} = createAsyncActionTypes(FETCH_EMAILS);

export const FETCH_EMAILS_URL = 'event/fetchEmailsUrl';
export const {
  pending: FETCH_EMAILS_URL_PENDING,
  fulfilled: FETCH_EMAILS_URL_FULFILLED,
  rejected: FETCH_EMAILS_URL_REJECTED,
} = createAsyncActionTypes(FETCH_EMAILS_URL);
